/**
 * A global namespace for `Pause` key.
 * e.which = 19
 */
const keyPause = 'Pause';

export default keyPause;
